/* ═══════════════════════════════════════════
   ROYAL CHAOS — THEME JS
   ═══════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  /* ─── GLITTER FIELD ─── */
  const field = document.getElementById('glitterField');
  if (field) {
    const colors = ['#FF1EBA', '#00E8D6', '#FFE600', '#FF6B00'];
    for (let i = 0; i < 40; i++) {
      const dot = document.createElement('div');
      dot.className = 'glitter-dot';
      const size = Math.random() * 4 + 1;
      const color = colors[Math.floor(Math.random() * colors.length)];
      dot.style.cssText = `
        width:${size}px; height:${size}px;
        background:${color};
        box-shadow: 0 0 ${size * 3}px ${color};
        left:${Math.random() * 100}%;
        top:${Math.random() * 100}%;
        --dur:${2 + Math.random() * 4}s;
        --delay:${Math.random() * 4}s;
      `;
      field.appendChild(dot);
    }
  }

  /* ─── COUNTDOWN TIMER ─── */
  const countdownEl = document.getElementById('countdown');
  if (countdownEl) {
    const h = parseInt(countdownEl.dataset.hours || 8);
    const m = parseInt(countdownEl.dataset.minutes || 47);
    const s = parseInt(countdownEl.dataset.seconds || 23);
    let totalSecs = h * 3600 + m * 60 + s;
    const cdH = document.getElementById('cd-h');
    const cdM = document.getElementById('cd-m');
    const cdS = document.getElementById('cd-s');
    if (cdH && cdM && cdS) {
      setInterval(function () {
        if (totalSecs <= 0) return;
        totalSecs--;
        cdH.textContent = String(Math.floor(totalSecs / 3600)).padStart(2, '0');
        cdM.textContent = String(Math.floor((totalSecs % 3600) / 60)).padStart(2, '0');
        cdS.textContent = String(totalSecs % 60).padStart(2, '0');
      }, 1000);
    }
  }

  /* ─── MOBILE NAV ─── */
  const mobileToggle = document.getElementById('mobileToggle');
  const mobileNav = document.getElementById('mobileNav');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      const isOpen = mobileNav.classList.toggle('open');
      mobileNav.setAttribute('aria-hidden', !isOpen);
      mobileToggle.textContent = isOpen ? '✕' : '☰';
    });
  }

  /* ─── CART DRAWER ─── */
  const cartDrawer = document.getElementById('cart-drawer');
  const cartBtn = document.getElementById('cartBtn');
  const cartClose = cartDrawer ? cartDrawer.querySelector('.cart-close') : null;
  const cartOverlay = cartDrawer ? cartDrawer.querySelector('.cart-drawer-overlay') : null;

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (cartBtn) cartBtn.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  /* ─── FETCH & RENDER CART ─── */
  function fetchCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        renderCartDrawer(cart);
        updateCartCount(cart.item_count);
      })
      .catch(err => console.warn('Cart fetch error:', err));
  }

  function renderCartDrawer(cart) {
    const body = document.getElementById('cart-drawer-body');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-empty-msg">Your cart is empty.<br>Go cause some chaos.</p>';
      return;
    }
    let html = '<div class="cart-drawer-items">';
    cart.items.forEach(function (item) {
      html += `
        <div class="cart-item" data-key="${item.key}">
          <div class="cart-item-img">
            ${item.image ? `<img src="${item.image}" alt="${item.product_title}">` : ''}
          </div>
          <div class="cart-item-details">
            <div class="cart-item-title">${item.product_title}</div>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item-variant">${item.variant_title}</div>` : ''}
            <div class="cart-item-price">${formatMoney(item.final_price)}</div>
            <div class="cart-item-qty">
              <button class="qty-btn cart-qty-minus" data-key="${item.key}">−</button>
              <span class="cart-qty-val">${item.quantity}</span>
              <button class="qty-btn cart-qty-plus" data-key="${item.key}">+</button>
              <button class="cart-remove" data-key="${item.key}">Remove</button>
            </div>
          </div>
          <div class="cart-item-total">${formatMoney(item.final_line_price)}</div>
        </div>
      `;
    });
    html += '</div>';
    html += `<div class="cart-subtotal-row" style="margin-top:20px; padding-top:16px; border-top:1px solid rgba(245,237,224,0.08);">
      <span>Subtotal</span><span>${formatMoney(cart.total_price)}</span>
    </div>`;
    body.innerHTML = html;

    // Bind qty buttons
    body.querySelectorAll('.cart-qty-minus').forEach(btn => {
      btn.addEventListener('click', function () {
        const key = this.dataset.key;
        const item = cart.items.find(i => i.key === key);
        if (item) updateCartItem(key, Math.max(0, item.quantity - 1));
      });
    });
    body.querySelectorAll('.cart-qty-plus').forEach(btn => {
      btn.addEventListener('click', function () {
        const key = this.dataset.key;
        const item = cart.items.find(i => i.key === key);
        if (item) updateCartItem(key, item.quantity + 1);
      });
    });
    body.querySelectorAll('.cart-remove').forEach(btn => {
      btn.addEventListener('click', function () {
        updateCartItem(this.dataset.key, 0);
      });
    });
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(r => r.json())
      .then(cart => {
        renderCartDrawer(cart);
        updateCartCount(cart.item_count);
      });
  }

  function updateCartCount(count) {
    const el = document.getElementById('cartCount');
    if (el) el.textContent = count;
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  /* ─── ADD TO CART (quick add on grids) ─── */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.product-add[data-product-id]');
    if (!btn) return;
    const id = btn.dataset.productId;
    if (!id) return;
    btn.textContent = '...';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(r => r.json())
      .then(() => {
        btn.textContent = '✓ Added';
        fetchCart();
        setTimeout(() => openCart(), 300);
        setTimeout(() => {
          btn.textContent = 'Add to Cart';
          btn.disabled = false;
        }, 2000);
      })
      .catch(() => {
        btn.textContent = 'Error';
        btn.disabled = false;
      });
  });

  /* ─── PRODUCT PAGE: ATC FORM ─── */
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const variantId = document.getElementById('variantId').value;
      const qty = parseInt(document.getElementById('qtyInput').value) || 1;
      const submitBtn = productForm.querySelector('.btn-atc');
      submitBtn.textContent = 'Adding...';
      submitBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
        .then(r => r.json())
        .then(() => {
          submitBtn.textContent = '✓ Added to Cart';
          fetchCart();
          setTimeout(() => openCart(), 400);
          setTimeout(() => {
            submitBtn.textContent = 'Add to Cart';
            submitBtn.disabled = false;
          }, 2500);
        })
        .catch(() => {
          submitBtn.textContent = 'Error — Try Again';
          submitBtn.disabled = false;
        });
    });

    // Qty controls
    const qtyInput = document.getElementById('qtyInput');
    const qtyMinus = document.getElementById('qtyMinus');
    const qtyPlus = document.getElementById('qtyPlus');
    if (qtyInput && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', () => { if (parseInt(qtyInput.value) > 1) qtyInput.value--; });
      qtyPlus.addEventListener('click', () => { qtyInput.value++; });
    }

    // Variant selector
    const variantBtns = productForm.querySelectorAll('.variant-btn');
    variantBtns.forEach(btn => {
      btn.addEventListener('click', function () {
        const pos = this.dataset.option;
        productForm.querySelectorAll(`.variant-btn[data-option="${pos}"]`).forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        updateSelectedVariant();
      });
    });

    function updateSelectedVariant() {
      // Simple single-option variant selection
      const activeBtn = productForm.querySelector('.variant-btn.active');
      if (activeBtn) {
        // In a real theme, this would match against product.variants JSON
        // For now, we update the hidden input — extend with metafield JSON as needed
      }
    }
  }

  /* ─── PRODUCT GALLERY THUMBS ─── */
  const thumbs = document.querySelectorAll('.product-thumb');
  const mainImg = document.getElementById('mainProductImg');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function () {
      if (mainImg) mainImg.src = this.dataset.src;
      thumbs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });

  /* ─── CART PAGE QTY ─── */
  document.addEventListener('click', function (e) {
    const minus = e.target.closest('.cart-qty-minus');
    const plus = e.target.closest('.cart-qty-plus');
    const remove = e.target.closest('.cart-remove');
    if (minus) {
      const key = minus.dataset.key;
      const valEl = minus.nextElementSibling;
      const newQty = Math.max(0, parseInt(valEl.textContent) - 1);
      changePageCartItem(key, newQty);
    }
    if (plus) {
      const key = plus.dataset.key;
      const valEl = plus.previousElementSibling;
      const newQty = parseInt(valEl.textContent) + 1;
      changePageCartItem(key, newQty);
    }
    if (remove) {
      changePageCartItem(remove.dataset.key, 0);
    }
  });

  function changePageCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(() => window.location.reload());
  }

  /* ─── PRODUCT RECOMMENDATIONS ─── */
  const relatedSection = document.querySelector('.related-products[data-url]');
  if (relatedSection) {
    fetch(relatedSection.dataset.url)
      .then(r => r.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const inner = doc.querySelector('.products-grid');
        if (inner) {
          const existing = relatedSection.querySelector('.products-grid');
          if (existing) existing.replaceWith(inner);
        }
      });
  }

});
